"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERRORS = void 0;
// eslint-disable-next-line max-classes-per-file
const bluebird_1 = __importDefault(require("bluebird"));
const complexDataError_1 = __importDefault(require("@powerednow/complexData/complexDataError"));
const complexData_1 = __importDefault(require("@powerednow/complexData/complexData"));
const entity_1 = __importDefault(require("./entity"));
const modelProperties_1 = __importDefault(require("./modelProperties"));
const modelLookup_1 = require("../modelLookup");
class UserTaxRateNotFoundError extends complexDataError_1.default {
    constructor() {
        super('User TaxRate Not found');
    }
}
const ERRORS = {
    UserTaxRateNotFoundError,
};
exports.ERRORS = ERRORS;
// eslint-disable-next-line no-redeclare
class UserTaxRate extends complexData_1.default {
    static get allowedAssociations() {
        return {
            userTaxRateFilter: {
                key: 'userTaxRateFilter',
                instance: (0, modelLookup_1.complexFindModel)('UserTaxRateFilter'),
                cascadeDelete: false,
                condition: {
                    taxrate_id: this.Entity.getFieldSymbols().id,
                },
            },
            companyIntegration: {
                key: 'companyIntegration',
                instance: (0, modelLookup_1.complexFindModel)('CompanyIntegration'),
                cascadeDelete: false,
                condition: {
                    company_id: this.Entity.getFieldSymbols().company_id,
                },
            },
        };
    }
    static get ERRORS() {
        return { ...complexData_1.default.ERRORS, ...ERRORS };
    }
    async getCalculationTypeId({ sourceCountryId, targetCountryId, taxCategoryId, documentGroupType, }) {
        const taxRateFilter = await this.findTaxRateFilters({
            sourceCountryId, targetCountryId, taxCategoryId, documentGroupType,
        });
        if (taxRateFilter && taxRateFilter[0]) {
            return taxRateFilter[0].data.calculation_type;
        }
        return null;
    }
    async isAllowed({ sourceCountryId, targetCountryId, taxCategoryId, documentGroupType, }) {
        if (await this.noFilters()) {
            return true;
        }
        const taxRateFilters = await this.findTaxRateFilters({
            sourceCountryId, targetCountryId, taxCategoryId, documentGroupType,
        });
        return taxRateFilters.length > 0;
    }
    async findTaxRateFilters({ sourceCountryId, targetCountryId, taxCategoryId, documentGroupType, }) {
        const integrationTypeRule = await this.getIntegrationTypeRule();
        const rules = [{
                fieldName: 'country_id',
                value: sourceCountryId,
            }, {
                fieldName: 'tax_category_id',
                value: taxCategoryId,
            }, {
                fieldName: 'document_group_type',
                value: documentGroupType,
            }, ...(integrationTypeRule ? [integrationTypeRule] : [])];
        const allowedByProperties = await this.findTaxRateFiltersByProperties(rules);
        if (targetCountryId) {
            const taxRateFiltersForCountry = await this.filterTaxRateFiltersForTargetCountry(allowedByProperties, sourceCountryId, targetCountryId);
            if (this.hasMultipleTaxRateFilterDefinition({
                sourceCountryId, targetCountryId, taxCategoryId, documentGroupType,
            }, taxRateFiltersForCountry)) {
                throw new Error('userTaxRate should have only one calculation type on all criteria items are defined.');
            }
            return taxRateFiltersForCountry;
        }
        return allowedByProperties;
    }
    async getIntegrationTypeRule() {
        const enabledIntegration = await this.getEnabledIntegration();
        return enabledIntegration ? {
            fieldName: `allowed_for_integration_type_${enabledIntegration.data.integration_type_id}`,
            value: true,
        } : null;
    }
    async getEnabledIntegration() {
        const companyIntegrations = await this.getAllCompanyIntegration();
        return companyIntegrations.find(companyIntegration => companyIntegration.data.is_enabled);
    }
    hasMultipleTaxRateFilterDefinition(criteria, taxRateFiltersForCountry) {
        return (this.isAllCriteriaItemDefined(criteria)) && taxRateFiltersForCountry.length > 1;
    }
    isAllCriteriaItemDefined(criteria) {
        return Object.values(criteria).every(criteriaItemValue => criteriaItemValue !== null && criteriaItemValue !== undefined);
    }
    async findTaxRateFiltersByProperties(rules) {
        const taxRateFilters = await this.getAllUserTaxRateFilter();
        return bluebird_1.default.reduce(taxRateFilters, async (matchedFilters, taxRateFilter) => {
            const taxRateFilterMatching = rules.every((rule) => {
                if (!UserTaxRate.ruleIsDefined(rule)
                    || !taxRateFilter.isFieldRequired(rule.fieldName)
                    || !taxRateFilter.isFieldAvailable(rule.fieldName)) {
                    return true;
                }
                return taxRateFilter.data[rule.fieldName] === rule.value;
            });
            if (taxRateFilterMatching) {
                matchedFilters.push(taxRateFilter);
            }
            return matchedFilters;
        }, []);
    }
    async filterTaxRateFiltersForTargetCountry(taxRateFilters, sourceCountryId, targetCountryId) {
        return bluebird_1.default.reduce(taxRateFilters, async (allowedFilters, taxRateFilter) => {
            const isAllowed = await taxRateFilter.allowedForTargetCountry(sourceCountryId, targetCountryId);
            if (isAllowed) {
                allowedFilters.push(taxRateFilter);
            }
            return allowedFilters;
        }, []);
    }
    async noFilters() {
        const taxRateFilters = await this.getAllUserTaxRateFilter();
        return taxRateFilters.length === 0;
    }
    static ruleIsDefined(rule) {
        return rule.value !== undefined && rule.value !== null;
    }
}
UserTaxRate.Entity = entity_1.default;
UserTaxRate.modelProperties = modelProperties_1.default;
exports.default = UserTaxRate;
//# sourceMappingURL=../../../../src/models/userTaxRate/index.js.map